const env = process.env.NODE_ENV;
const { protocol } = window.location;

console.log('当前环境: ', env);

export default function getDomain(domainConfig) {
    let domain = '';
    switch (env) {
        case 'development':
        case 'staging':
            domain = domainConfig.devEnv;
            break;
        case 'production':
            domain = domainConfig.onlineEnv;
            break;
        default:
            domain = domainConfig.rapEnv;
            break;
    }
    return `${protocol}//${domain}`;
}
